var _rect, _path, _rect2, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13,
    fill: "#201E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1193 11.6362H21.7343C20.891 11.6419 20.0904 11.2611 19.5561 10.6003L18.4414 9.0362C17.9159 8.36961 17.1153 7.98709 16.2733 8.00033H13.8803C9.58513 8.00033 8.00001 10.5589 8.00001 14.9095V19.6124C7.99467 20.1295 30.9981 20.1289 30.9996 19.6124V18.245C31.0201 13.8944 29.4758 11.6362 25.1193 11.6362Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.2928,
    width: 23.8635,
    height: 20.3281,
    rx: 6,
    fill: "#FF7A2F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21.5,
    r: 6.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15C18.7761 15 17.1228 15.6848 15.9038 16.9038C14.6848 18.1228 14 19.7761 14 21.5C14 23.2239 14.6848 24.8772 15.9038 26.0962C17.1228 27.3152 18.7761 28 20.5 28C22.2239 28 23.8772 27.3152 25.0962 26.0962C26.3152 24.8772 27 23.2239 27 21.5C27 19.7761 26.3152 18.1228 25.0962 16.9038C23.8772 15.6848 22.2239 15 20.5 15ZM18.1372 16.3244L20.0954 17.4667V18.848L17.8456 20.434L16.5781 19.9733L16.0694 17.9323C16.6247 17.2433 17.3327 16.6928 18.1372 16.3244ZM14.8401 22.0623L16.3246 20.746L17.5807 21.2018L18.4297 23.8749L17.8472 24.7467H15.8297C15.2752 23.9515 14.9344 23.0271 14.8401 22.0623ZM19.1781 27.0331L18.5159 25.2083L19.0927 24.3446H21.9097L22.4874 25.2083L21.8252 27.0323C20.955 27.2401 20.0482 27.2401 19.1781 27.0323V27.0331ZM25.1702 24.7467H23.1569L22.5719 23.8733L23.4047 21.2026L24.6779 20.7444L26.1599 22.0623C26.0656 23.0271 25.7248 23.9515 25.1702 24.7467ZM24.9346 17.938L24.426 19.9717L23.139 20.4348L20.9071 18.8488V17.4676L22.8644 16.3244C23.6704 16.6939 24.3792 17.2461 24.9346 17.9372V17.938Z",
    fill: "#343843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon1);
export default __webpack_public_path__ + "static/media/group_icon1.a5489c09da43e225a2d0db51f8095555.svg";
export { ForwardRef as ReactComponent };